import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
// import { Link } from '@bd/bdcore-named-routes';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../styles';

const styles = css`
  display:flex;
  flex-flow:row wrap;
  justify-content: center;
  position: relative;

  .homeCta_wrapper {
    width:100%;
    @media (min-width: 991px) {
      width:33.333333%;
    }
  }
  .homeCta_wrapper:last-child {
    .homeCta_item {
      border-right:0;
    }
  }
  .homeCta_item {
    width:100%;
    border-top:8px solid white;
    padding-top:100%;
    position: relative;
    display: block;
    background-size: cover;
    background-position: center;
    @media (min-width: 480px) {
      padding-top:50%;
    }
    @media (min-width: 991px) {
      border-right:8px solid white;
      padding-top:100%;
    }
  }
  .homeCta_label {
    position: absolute;
    bottom:0;
    left:0;
    background:white;
    padding:15px;
    font:700 18px/1.1 ${typography.SansSerif};
    text-transform: uppercase;
    @media (min-width: 991px) {
      font:700 20px/1.1 ${typography.SansSerif};
      padding:20px;
    }
    .homeCta_label-colorOne {
      color:${colors.color1};
    }
    .homeCta_label-colorTwo {
      color:${colors.color2};
    }
  }
`;

function HomeCTA({ page }) {
  return (
    <div className={styles}>
      {
        get(page, 'product_cta').map(item => (
          <div className="homeCta_wrapper" key={item.label_color_one}>
            <a href={item.link_url} className="homeCta_item" style={{ backgroundImage: `url(${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 800, height: 800 })})` }}>
              <div className="homeCta_label"><span className="homeCta_label-colorOne">{item.label_color_one}</span> <span className="homeCta_label-colorTwo">{item.label_color_two}</span></div>
            </a>
          </div>

        ))
      }
    </div>
  );
}
HomeCTA.propTypes = {
  page: PropTypes.object.isRequired,
};

export default HomeCTA;



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeCTA.js